import { EMPTY_VALUE } from '@/constants/app.constants';

export function EmptyValue() {
  return <span className="text-muted-foreground">{EMPTY_VALUE}</span>;
}
